import { StartedCard } from 'components/base';
import useTranslation from 'hooks/useTranslation';

const GettingStarted = () => {
  const translation = useTranslation();

  const startedList = [
    {
      title: translation.landingPage,
      content: translation.singlePage,
    },
    {
      title: translation.webHosting,
      content: translation.fastAndReliable,
    },
    {
      title: translation.emailHosting,
      content: translation.secureAndReliable,
    },
    {
      title: translation.brandDesign,
      content: translation.professionalBrandGuideline,
    },
    {
      title: translation.logoDesign,
      content: translation.customLogo,
    },
    {
      title: translation.domainServices,
      content: translation.easyAndHassleFree,
    },
  ];

  return (
    <div className="flex flex-col py-20 px-4 lg:items-center lg:px-[147px] lg:py-[140px]">
      <p className="text-xs font-bold uppercase tracking-wide text-primary-light-blue">
        {translation.gettingStarted}
      </p>
      <p className="mt-3 text-2xl font-bold text-primary-blue lg:mt-4 lg:text-4xl">
        {translation.weDeliverMore}
      </p>
      <p className="mt-3 text-sm font-normal tracking-wide text-primary-grey lg:mt-4 lg:max-w-[848px] lg:text-center lg:text-base">
        {translation.wheterYouAlreadyHave}
      </p>

      <div className="mt-[60px] grid grid-cols-1 gap-y-8 lg:mt-[80px] lg:grid-cols-2 lg:gap-y-10 lg:gap-x-[60px]">
        {startedList.map((item, idx) => (
          <StartedCard
            key={idx}
            title={item.title}
            content={item.content}
            idx={idx}
          />
        ))}
      </div>
    </div>
  );
};

export default GettingStarted;
